<template>
  <div class="Feature-Container">
    <div class="Feature">
      <router-link :to="page.url"></router-link>
      <aside>
        <div class="meta">
          <h3 v-if="title" v-html="title"></h3>
          <ul v-if="page.tags" class="bullet-list">
            <li v-for="tag in page.tags" :key="tag.slug">
              <router-link :to="tag.slug" v-if="tag.slug" v-html="tag.name"></router-link>
              <span v-else v-html="tag.name"></span>
            </li>
          </ul>
          <div class="location" v-if="page.template === 'event'">
            <div>{{ date }}</div>
            <div>{{ page.formatted.time }}</div>
            <div v-html="page.location_name"></div>
          </div>
        </div>
        <IconPlayBroadcast
          v-if="type === 'broadcast' && page.audio"
          class="button-set"
          variation="button"
          v-bind="page.audio"
          :page-url="page.url"
          label="Play Broadcast"
        ></IconPlayBroadcast>
        <div v-if="type === 'event'" class="button-set">
          <IconAddToCalendar :page="page">
            <button class="icon-button-plus"></button><label>Add to Calendar</label>
          </IconAddToCalendar>
        </div>
      </aside>
      <figure v-if="thumbnail" :class="{ cover: page.cover }">
        <img :data-flickity-lazyload="thumbnailUrl">
      </figure>
    </div>
  </div>
</template>

<script>
import IconPlayBroadcast from './IconPlayBroadcast'
import IconAddToCalendar from './IconAddToCalendar'

export default {
  name: 'Feature',
  components: { IconAddToCalendar, IconPlayBroadcast },
  props: {
    page: Object,
    default: { },
    type: {
      type: String,
      default: 'broadcast'
    }
  },
  computed: {
    title () {
      const max = 90
      if (this.page.title.length > max) {
        return this.page.title.substring(0, max).trim() + '…'
      } else {
        return this.page.title
      }
    },
    thumbnailUrl () {
      return this.thumbnail.sizes.medium_large || this.thumbnail.url
    },
    thumbnail () {
      return this.$store.getters.getThumbnail(this.page)
    },
    date () {
      return this.page.formatted.date
        ? this.page.formatted.date.replace(', ' + (new Date()).getFullYear(), '')
        : ''
    }
  }
}
</script>

<style scoped>
.Feature {
  border-radius: var(--br1);
  height: 44vmin;
  background-color: #000;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-wrap: wrap;
  color: #fff;
  text-align: left;
  padding: 0;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.Feature > a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}

ul {
  font: var(--small);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

aside {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--p2);
  padding-right: 0;
  width: 45%;
}

aside .meta {
  position: relative;
  z-index: 2;
}

h3 {
  margin-bottom: 0.5rem;
}

.Feature >>> .button-set {
  cursor: pointer;
  position: relative;
  z-index: 5;
}

.Feature >>> .button-set label {
  font: var(--small);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: inherit;
}

.Feature >>> .button-set button {
  vertical-align: middle;
  margin-right: 1rem;
}

.Feature .location {
  font: var(--small);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: inherit;
}

aside p {
  font: var(--small);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

figure {
  position: relative;
  width: 55%;
}

figure > img {
  object-fit: contain;
  height: 100%;
  width: 100%;
}

figure > img:not([src]) {
  opacity: 0;
}

figure:not(.cover) > img {
  position: absolute;
  top: 2rem;
  left: 2rem;
  height: calc(100% - 4rem);
  width: calc(100% - 4rem);
}

figure.cover {
  opacity: 0.8;
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

figure.cover > img {
  object-fit: cover;
}

@media (max-width: 1000px) {
  .Feature {
    height: 55vh;
    flex-direction: column-reverse;
  }

  figure { flex: 1; }
  aside, figure { width: 100%; }
  aside { padding-right: 2rem; }

  .meta {
    margin-bottom: 1rem;
  }
}
</style>